module.exports = "<app-product-list [query] = \"route.snapshot.queryParams.q\"></app-product-list>"